import { Routes } from '@angular/router';
import { authGuard } from './shared/guards/auth.guard';
import { accessGuard } from './shared/guards/access.guard';

export const routes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'auth/login'
    },
    {
        path: 'auth',
        canActivate: [authGuard],
        loadComponent: () => import('./auth/auth.component'),
        title: 'RÜM',
        children: [
            {
                path: '',
                redirectTo: 'login',
                pathMatch: 'full'
            },
            {
                path: 'login',
                loadComponent: () => import('./auth/login/login.component'),
                title: 'RÜM - Login'
            },
            {
                path: 'recover',
                loadComponent: () => import('./auth/recover/recover.component'),
                title: 'RÜM - Recuperar Contraseña'
            }
        ]
    },
    {
        path: 'auth/sent-recover',
        loadComponent: () => import('./auth/sent-recover/sent-recover.component'),
        title: 'RÜM - Correo enviado'
    },
    {
        path: 'dashboard',
        canActivate: [authGuard],
        canActivateChild: [accessGuard],
        loadComponent: () => import('./dashboard/dashboard.component'),
        data: { breadcrumb: 'Inicio' },
        children: [
            {
                path: '',
                redirectTo: 'inicio', pathMatch: 'full'
            },
            {
                path: 'configuraciones',
                loadComponent: () => import('./dashboard/configuraciones/configuraciones.component'),
                title: 'RÜM - Configuraciones',
                data: { breadcrumb: 'Configuraciones' },
                children: [
                    {
                        path: '',
                        redirectTo: 'usuarios',
                        pathMatch: 'full'
                    },
                    {
                        path: 'menu',
                        loadComponent: () => import('./dashboard/configuraciones/menu/menu.component'),
                        title: 'Menu',
                        data: { breadcrumb: 'Menu' }
                    },
                    {
                        path: 'roles',
                        data: { breadcrumb: 'Roles' },
                        children: [
                            {
                                path: '',
                                loadComponent: () => import('./dashboard/configuraciones/roles/roles.component'),
                                title: 'Roles',
                                data: { breadcrumb: null }
                            },
                            {
                                path: 'nuevo',
                                loadComponent: () => import('./dashboard/configuraciones/roles/roles-editor/roles-editor.component'),
                                title: 'Nuevo Rol',
                                data: { breadcrumb: 'Nuevo' }
                            },
                            {
                                path: ':id',
                                loadComponent: () => import('./dashboard/configuraciones/roles/roles-editor/roles-editor.component'),
                                title: 'Editar Rol',
                                data: { breadcrumb: 'Editar' }
                            }
                        ]
                    },
                    {
                        path: 'usuarios',
                        loadComponent: () => import('./dashboard/configuraciones/usuarios/usuarios.component'),
                        title: 'RÜM - Usuarios',
                        data: { breadcrumb: 'Usuarios' },
                        children: [
                            {
                                path: '',
                                loadComponent: () => import('./dashboard/configuraciones/usuarios/usuarios-home/usuarios-home.component'),
                                title: 'RÜM - Usuarios',
                                data: { breadcrumb: null },
                            },
                            {
                                path: 'detalle',
                                loadComponent: () => import('./dashboard/configuraciones/usuarios/usuarios-detalle/usuarios-detalle.component'),
                                title: 'Nuevo usuario',
                                data: { breadcrumb: 'Nuevo' }
                            },
                            {
                                path: 'detalle/:id',
                                loadComponent: () => import('./dashboard/configuraciones/usuarios/usuarios-detalle/usuarios-detalle.component'),
                                title: 'Detalles',
                                data: { breadcrumb: 'Detalle' }
                            },
                            {
                                path: 'roles',
                                loadComponent: () => import('./dashboard/configuraciones/roles/roles.component'),
                                title: 'RÜM - Roles',
                                data: { breadcrumb: 'Roles' },
                            },
                        ]
                    },
                ]
            },
            {
                path: 'contenido',
                loadComponent: () => import('./dashboard/contenido/contenido.component'),
                title: 'RÜM - Contenido',
            },
            {
                path: 'establecimientos',
                loadComponent: () => import('./dashboard/establecimientos/establecimientos.component'),
                title: 'RÜM - Establecimientos',
                data: { breadcrumb: 'Establecimientos' },
                children: [
                    {
                        path: '',
                        loadComponent: () => import('./dashboard/establecimientos/establecimientos-home/establecimientos-home.component'),
                        title: 'Lista establecimientos',
                        data: { breadcrumb: null },
                    },
                    {
                        path: 'detalle/:id',
                        loadComponent: () => import('./dashboard/establecimientos/establecimientos-detalle/establecimientos-detalle.component'),
                        title: 'Detalles',
                        data: { breadcrumb: 'Detalle' }
                    },
                ]
            },
            {
                path: 'finanzas',
                loadComponent: () => import('./dashboard/finanzas/finanzas.component'),
                title: 'RÜM - Finanzas',
                data: { breadcrumb: 'Finanzas' },
                children: [
                    {
                        path: '',
                        redirectTo: 'resumen',
                        pathMatch: 'full'
                    },
                    {
                        path: 'resumen',
                        loadComponent: () => import('./dashboard/finanzas/finanzas-home/finanzas-home.component'),
                        data: { breadcrumb: 'Resumen' },
                    },
                    {
                        path: 'comisiones',
                        loadComponent: () => import('./dashboard/finanzas/finanzas-comisiones/finanzas-comisiones.component'),
                        data: { breadcrumb: 'Comisiones' }
                    },
                    {
                        path: 'transacciones',
                        loadComponent: () => import('./dashboard/finanzas/finanzas-transacciones/finanzas-transacciones.component'),
                        data: { breadcrumb: 'Transacciones' }
                    },
                    {
                        path: 'reportes',
                        loadComponent: () => import('./dashboard/finanzas/reportes/reportes.component'),
                        data: { breadcrumb: 'Reportes' }
                    }
                ]
            },
            {
                path: 'incidencias',
                loadComponent: () => import('./dashboard/incidencias/incidencias.component'),
                title: 'RÜM - Incidencias',
                data: { breadcrumb: 'Incidencias' },
            },
            {
                path: 'inicio',
                loadComponent: () => import('./dashboard/inicio/inicio.component'),
                title: 'RÜM - Inicio',
            },
            {
                path: 'onboarding',
                loadComponent: () => import('./dashboard/onboarding/onboarding.component'),
                data: { breadcrumb: 'On-boarding' },
                children: [
                    {
                        path: '',
                        loadComponent: () => import('./dashboard/onboarding/onboarding-home/onboarding-home.component'),
                        title: 'On-Boarding',
                        data: { breadcrumb: null },
                    },
                    {
                        path: 'detalle/:id',
                        loadComponent: () => import('./dashboard/onboarding/onboarding-detalle/onboarding-detalle.component'),
                        title: 'Detalles',
                        data: { breadcrumb: 'Detalle' }
                    },
                ]
            },
            {
                path: 'reservas',
                loadComponent: () => import('./dashboard/reservas/reservas.component'),
                title: 'RÜM - Reservas',
                data: { breadcrumb: 'Reservas' },
                children: [
                    {
                        path: '',
                        loadComponent: () => import('./dashboard/reservas/reservas-home/reservas-home.component'),
                        title: 'Lista reservas',
                        data: { breadcrumb: null },
                    },
                    {
                        path: 'detalle/:id',
                        loadComponent: () => import('./dashboard/reservas/detalle-reserva/detalle-reserva.component'),
                        title: 'Detalles reserva',
                        data: { breadcrumb: 'Detalle' }
                    },
                ]
            },
            {
                path: 'reviews',
                loadComponent: () => import('./dashboard/resenias/resenias.component'),
                title: 'RÜM - Reseñas y comentarios',
                data: { breadcrumb: 'Reseñas y comentarios' },
            },
        ]
    },
    {
        path: '**',
        pathMatch: 'full',
        redirectTo: 'auth/login',
    }
];